// extracted by mini-css-extract-plugin
module.exports = {"inputs":"InputBlock_inputs__2iEgN"};